import { Controller } from 'stimulus'
import { useClickOutside } from 'stimulus-use'

export default class extends Controller {
  static targets = ['toggle', 'container', 'charges', 'arrowUp', 'arrowDown']

  connect() {
    useClickOutside(this)
  }

  toggleCharges() {
    this.chargesTarget.classList.contains('hidden')
      ? this.openCharges()
      : this.closeCharges()
  }

  openCharges() {
    this.chargesTarget.classList.remove('hidden')
    this.arrowUpTarget.classList.remove('hidden')
    this.arrowDownTarget.classList.add('hidden')
    this.flipAndCalculateMaxHeight()
  }

  flipAndCalculateMaxHeight() {
    const { bottom } = this.chargesTarget.getBoundingClientRect()

    if (bottom > window.innerHeight) {
      this.calculateMaxHeight('top')
      this.chargesTarget.classList.add('bottom-6')
      this.chargesTarget.classList.remove('top-6')
    } else {
      this.calculateMaxHeight('bottom')
    }
  }

  // Calculate the available space between the opener and the side (top or bottom) of the viewport
  // So the box cannot grow beyond that
  calculateMaxHeight(side = 'top') {
    if (side === 'top') {
      const spaceAbove = this.toggleTarget.getBoundingClientRect().top
      this.containerTarget.style.maxHeight = spaceAbove - 40 + 'px'
    } else {
      const spaceBelow =
        window.innerHeight - this.toggleTarget.getBoundingClientRect().bottom
      this.containerTarget.style.maxHeight = spaceBelow - 40 + 'px'
    }
  }

  closeCharges() {
    this.chargesTarget.classList.add('hidden')
    this.arrowUpTarget.classList.add('hidden')
    this.arrowDownTarget.classList.remove('hidden')
    this.resetPosition()
  }

  resetPosition() {
    this.chargesTarget.classList.remove('bottom-6')
    this.chargesTarget.classList.add('top-6')
  }

  clickOutside() {
    if (this.hasChargesTarget) this.closeCharges()
  }
}
